<template>
  <section class="reference-recovery-page"><div class="reference-recovery-card"><h1>{{ step===0?'验证方式':step===1?'身份验证':'重设密码' }}</h1><div v-if="step" class="reference-recovery-progress" aria-label="找回密码进度"><i v-for="index in 3" :key="index" :class="{active:index<=step}"></i></div>
    <div v-if="step===0" class="reference-recovery-methods"><button @click="selectChannel('PHONE')"><img :src="referenceAsset('auth','recovery-phone')" alt="" /><span><strong>手机验证</strong><small>发送验证码至您所绑定的手机号码</small></span><b>›</b></button><button @click="selectChannel('EMAIL')"><img :src="referenceAsset('auth','recovery-email')" alt="" /><span><strong>邮箱验证</strong><small>发送验证码至您所绑定的邮箱账号</small></span><b>›</b></button></div>
    <form v-else-if="step===1" class="reference-recovery-fields" @submit.prevent="sendIdentityCode"><label><span class="sr-only">用户名</span><input v-model.trim="resetForm.username" required maxlength="64" autocomplete="username" placeholder="请输入您的用户名" /></label><label><span class="sr-only">{{ channel==='PHONE'?'绑定手机号码':'绑定邮箱账号' }}</span><input v-model.trim="resetForm.account" required :type="channel==='PHONE'?'tel':'email'" :autocomplete="channel==='PHONE'?'tel':'email'" :placeholder="channel==='PHONE'?'请输入您所绑定的手机号码':'请输入您所绑定的邮箱账号'" /></label><p v-if="error" class="field-error" role="alert">{{ error }}</p><button class="reference-recovery-submit" :disabled="resetCodeSending || !identityComplete">{{ resetCodeSending?'验证中…':'下一步' }}</button><button class="reference-recovery-back" type="button" :disabled="resetCodeSending" @click="step=0">上一步</button></form>
    <form v-else class="reference-recovery-fields" @submit.prevent="finish"><label><span class="sr-only">验证码</span><div class="reference-recovery-code"><input v-model.trim="resetForm.code" required maxlength="12" autocomplete="one-time-code" placeholder="请输入验证码" /><button type="button" :disabled="resetCodeSending || submitting" @click="sendResetCode">{{ resetCodeSending?'发送中…':'重新发送' }}</button></div></label><label><span class="sr-only">新密码</span><input v-model="resetForm.newPassword" required type="password" autocomplete="new-password" placeholder="请输入新密码" /></label><label><span class="sr-only">确认新密码</span><input v-model="confirmation" required type="password" autocomplete="new-password" placeholder="请再次输入新密码" /></label><p v-if="error" class="field-error" role="alert">{{ error }}</p><button class="reference-recovery-submit" :disabled="submitting">{{ submitting?'提交中…':'确认重设' }}</button><button class="reference-recovery-back" type="button" :disabled="submitting" @click="step=1">上一步</button></form>
    <footer><button @click="openAuthPage('login')"><img :src="referenceAsset('auth','recovery-back')" alt="" />返回登录</button><button @click="openCustomerService"><img :src="referenceAsset('auth','recovery-help')" alt="" />联系客服</button></footer></div></section>
</template>
<script setup>
import { computed, onBeforeUnmount, ref } from 'vue'
import { useAppContext } from '../../composables/appContext'
import { referenceAsset } from '../../config/referencePresentation.js'
const { resetForm, resetCodeSending, sendResetCode, submitResetPassword, openAuthPage, openCustomerService }=useAppContext()
const step=ref(0),channel=ref('PHONE'),confirmation=ref(''),error=ref(''),submitting=ref(false)
const identityComplete=computed(()=>Boolean(resetForm.value.username.trim()&&resetForm.value.account.trim()))
function selectChannel(value){channel.value=value;resetForm.value.account='';resetForm.value.code='';resetForm.value.newPassword='';confirmation.value='';error.value='';step.value=1}
async function sendIdentityCode(){if(!identityComplete.value||resetCodeSending.value)return;error.value='';if(channel.value==='PHONE'&&resetForm.value.account.includes('@')){error.value='请输入绑定的手机号码';return}const sent=await sendResetCode();if(active&&sent)step.value=2}
async function finish(){if(submitting.value)return;error.value='';if(resetForm.value.newPassword!==confirmation.value){error.value='两次输入的密码不一致';return}submitting.value=true;try{await submitResetPassword()}finally{submitting.value=false}}
let active=true
onBeforeUnmount(()=>{active=false;resetForm.value.newPassword='';resetForm.value.code=''})
</script>

<style scoped>
.reference-recovery-card {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.reference-recovery-card h1 {
  margin-bottom: 32px;
}
.reference-recovery-progress {
  margin-bottom: 32px;
}
.reference-recovery-methods {
  gap: 20px;
  margin-bottom: 0;
}
.reference-recovery-methods > button {
  min-height: 96px;
  padding: 20px;
}
.reference-recovery-methods small {
  margin-top: 8px;
  line-height: 1.5;
}
.reference-recovery-fields {
  gap: 20px;
}
.reference-recovery-fields input {
  height: 48px;
  border-color: #dce7f2;
  border-radius: 11px;
  background: #f7faff;
}
.reference-recovery-fields input::placeholder {
  color: #8b97ac;
}
.reference-recovery-fields input:focus {
  border-color: #39aaf0;
  outline: none;
  box-shadow: 0 0 0 3px rgba(42,164,239,.1);
}
.reference-recovery-submit {
  border-radius: 11px;
}
.reference-recovery-submit:disabled {
  color: #8b95a6;
  background: #edf1f6;
  opacity: 1;
}
.reference-recovery-back {
  align-self: center;
  margin-top: 0;
  padding: 4px 12px;
}
.reference-recovery-code {
  border-color: #dce7f2;
  border-radius: 11px;
  background: #f7faff;
}
.reference-recovery-code > input {
  height: 46px;
  border: 0;
  border-radius: 0;
  background: transparent;
}
.reference-recovery-code > input:focus {
  outline: none;
  box-shadow: none;
}
.reference-recovery-code:focus-within {
  border-color: #39aaf0;
  box-shadow: 0 0 0 3px rgba(42,164,239,.1);
}
.reference-recovery-code > button {
  flex: none;
}
.reference-recovery-card > footer {
  gap: 16px;
  margin-top: 0;
  padding: 20px 0 0;
  background: transparent;
  color: #7b819e;
}
.reference-recovery-card > footer > button {
  padding: 0;
  min-height: 32px;
  color: #529fdf;
}
@media (max-width: 767px) {
  .reference-recovery-methods > button {
    padding: 18px 14px;
  }
}
</style>
